export default __webpack_public_path__ + "static/media/Settings.67a37782.svg";